import {
    getTagDetailById,
    updateTagAction,
    createTagAction,
    deleteTagDetailById
} from "../api/actions/TagActions";
import {
    TAG_CRUD_FORM_CANCEL,
    TAG_CRUD_FORM_SAVE,
    TAG_CRUD_FORM_CREATE,
    TAG_CRUD_FORM_LOADING,
    TAG_CRUD_FORM_DONE,
    TAG_CRUD_FORM_DELETE,
    UPDATE_TAGS_STATUS
} from "./actions/TagActions";
import { getAllDiscountsByTagId } from "../api/actions/DiscountActions";
import { storeAllTagsAction, getAllTagsAction } from "../api/actions/actions";
import store from "../redux/Store";
import { dispatchCustomEvent } from "../event/EventRouter";

export const fetchAllTagsEvent = (payload) => {
    let tags = store.getState().base.tags;
    if (payload || !(Array.isArray(tags) && tags.length > 0)) {
        store.dispatch(getAllTagsAction())
            .unwrap()
            .then((result) => {
                store.dispatch(storeAllTagsAction(result.content));
            })
            .catch(error => {
                console.error('fetchAllTagsEvent', error);
            });
    }
};
export const fetchAllTags_Event = ({ detail: { payload } }) => {
    let tags = store.getState().base.tags;
    if (payload || !(Array.isArray(tags) && tags.length > 0)) {
        store.dispatch(getAllTagsAction())
            .unwrap()
            .then((result) => {
                store.dispatch(storeAllTagsAction(result.content));
            })
            .catch(error => {
                console.error('fetchAllTagsEvent', error);
            });
    }
};
export const fetchAllDiscountsByTagIdEvent = (tagId) => {
    if (tagId > 0) {
        getAllDiscountsByTagId()
            .then((result) => {
                store.dispatch(storeAllTagsAction(result.content));
            })
            .catch(error => {
                console.error('fetchAllTagsEvent', error);
            });
    }
};
export const createTagCrudFromEvent = (e) => {
    return async (dispatch) => {
        dispatch(TAG_CRUD_FORM_CREATE());
    };
};
export const cancelTagCrudFromEvent = (e) => {
    return async (dispatch) => {
        dispatch(TAG_CRUD_FORM_CANCEL());
    };
};
export const saveTagCrudFromEvent = (json, reduxDispatch, tags) => {
    return async (dispatch) => {
        if (json.id > 0) {
            updateTagAction(json)
                .then(result => {
                    if (result.content > 0) {
                        dispatch(TAG_CRUD_FORM_CANCEL());
                        tags.forEach((tag, index) => {
                            if (tag.id == json.id) {
                                tag.name = json.name;
                                tag.color = json.color;
                            }
                        });
                        reduxDispatch(storeAllTagsAction([...tags]));
                    }
                })
                .catch(error => {
                    console.log('editTagEvent.response', error);
                });
        } else {
            createTagAction(json)
                .then(result => {
                    if (result.content > 0) {
                        dispatch(TAG_CRUD_FORM_CANCEL());
                        let tag = {
                            id: result.content,
                            name: json.name,
                            color: json.color
                        };
                        reduxDispatch(storeAllTagsAction([...tags, tag]));
                    }
                })
                .catch(error => {
                    console.log('editTagEvent.response', error);
                });
        }
    };
};
export const editTagEvent = (id) => {
    return async (dispatch) => {

        dispatch(TAG_CRUD_FORM_LOADING);

        getTagDetailById(id)
            .then(result => {
                if (result.content) {
                    dispatch(TAG_CRUD_FORM_DONE(result.content));
                } else {
                    dispatch(TAG_CRUD_FORM_CANCEL());
                }
            })
            .catch(error => {
                dispatch(TAG_CRUD_FORM_CANCEL(error));
            });
    };
};
export const getDeleteTagEvent = (id) => {
    return async (dispatch) => {
        if (id > 0) {
            dispatch(TAG_CRUD_FORM_LOADING);
            getTagDetailById(id)
                .then(result => {
                    dispatch(TAG_CRUD_FORM_DELETE(result.content));
                })
                .catch(error => {
                    dispatch(TAG_CRUD_FORM_CANCEL(error));
                });

        }
    };
};

export const deleteTagEvent = (json, reduxDispatch, tags) => {
    return async (dispatch, state) => {
        if (json.id > 0) {
            if (typeof state.tags != 'object') {
                state.tags = {};
            }
            deleteTagDetailById(json.id)
                .then(result => {
                    console.log('deleteTagEvent.response', result.content);
                    if (result.content > 0) {
                        state.tags[json.id] = {
                            [result.content > 0 ? 'deleted' : 'error']: true,
                            data: null
                        };
                        //reduxDispatch(storeAllTagsAction(tags.filter(tag => tag.id != json.id)));
                        dispatch(UPDATE_TAGS_STATUS(state.tags));
                        dispatch(TAG_CRUD_FORM_CANCEL());
                    }

                })
                .catch(error => {
                    dispatch(TAG_CRUD_FORM_CANCEL(error));
                });
        }
    };
};

export const FETCH_ALL_DISCOUNTS_BY_TAG_ID_EVENT = (payload) => ({
    class: 'custom_event',
    event: {
        type: 'default',
        name: 'fetch_all_discounts_by_tag_id_update_redux_Store',
        call: fetchAllDiscountsByTagIdEvent,
        payload: payload
    }
});

export const FETCH_ALL_TAGS_EVENT = (payload) => ({
    class: 'custom_event',
    event: {
        type: 'default',
        name: 'fetch_all_tags_update_redux_Store',
        call: fetchAllTags_Event,
        payload: payload
    }
});

export const dispatch_FetchAllTagsEvent = (payload) => dispatchCustomEvent(FETCH_ALL_TAGS_EVENT(payload));
export const dispatch_FetchAllDiscountsByTagIdEvent = (payload) => dispatchCustomEvent(FETCH_ALL_DISCOUNTS_BY_TAG_ID_EVENT(payload));